"use client"

import { QuickLinksContent } from "@/(admin)/modules/ui-builder/config/themes/tamda-one/QuickLinks/components/QuickLinksContent"
import { useUIBuilderLocaleStore } from "@/(admin)/modules/ui-builder/store/useUIBuilderLocaleStore"
import { QuickLinksProps } from "@/types/types"
import { ComponentConfig } from "@measured/puck"
import { useParams } from "next/navigation"
import { generateResponsiveCSS } from "../../../lib/helper"

export const RenderConfig: ComponentConfig<QuickLinksProps> = {
  render: ({ links, className, styles, responsiveType }) => {
    const params = useParams()
    const storeLocale = useUIBuilderLocaleStore(state => state.locale)
    const locale = (params?.locale as string) || storeLocale || "vi"
    const id = `quick-links-${Math.random().toString(36).substr(2, 9)}`
    const responsiveCSS = generateResponsiveCSS(id, styles || {}, responsiveType || "desktopFirst")

    return (
      <>
        {responsiveCSS}
        <QuickLinksContent id={id} links={links} className={className} locale={locale} />
      </>
    )
  },
}
